import Api_Usermanagement from '../api-usermanagement'
import Api_Masterdata from '../api-masterdata'
import Api_SAP from '../api-sap'
import Api_H2H from '../api-h2h'
import Api_Masterdata_v2 from '../api-masterdata-v2'
import axios from 'axios'

const api_usermanagement = new Api_Usermanagement().init()
const api_masterdata = new Api_Masterdata().init()
const api_masterdata_v2 = new Api_Masterdata_v2().init()
const api_sap = new Api_SAP().init()
const api_h2h = new Api_H2H().init()

let config = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'X-Credentials': localStorage.getItem('credential')
  },
}

const createQueryString = (params) => {
  return Object.keys(params)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
}

const getSalesArea = (id) => {
  return api_masterdata.get(`/customer/sales-area/list?customer_code=${id}&division=ZZ`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getCommodities = () => {
  return api_masterdata.get(`/commodity/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSalesAreaLetter = () => {
  return api_usermanagement.get(`/sales-org`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getEndUser = (id) => {
  return api_masterdata.get(`/enduser/list?customer_code=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getAllEndUser = () => {
  return api_masterdata.get(`/enduser/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSector = (id, options = {}) => {
  return api_usermanagement.get(`/sector/list?distribution_channel=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      credentials: options?.credentials,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getIncoterm = () => {
  return api_usermanagement.get(`/incoterm/get-all`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getFindocTypes = (sector_id = '') => {
  return api_usermanagement.get(`/findoc/type-list?sector_id=` + sector_id, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getProvince = () => {
  return api_usermanagement.get(`/regions`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getCity = (id) => {
  return api_usermanagement.get(`/cities?regions=${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getProdusen = () => {
  return api_masterdata.get(`/sales-org`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getTOP = () => {
  return api_usermanagement.get(`/term-of-payment/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPlant = (sales, distribution, region, options = {}) => {
  const opt = new URLSearchParams(options).toString()
  return api_masterdata.get(
    `/plant/list?sales_org_code=${sales}&distribution_channel=${distribution}&region_code=${region}&` + opt,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getSupplyPoint = (options = {}) => {
  const opt = new URLSearchParams(options).toString()
  return api_masterdata.get(
    `/supply-point/list?` + opt,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getPlant2 = (sales, distribution, number) => {
  return api_masterdata.get(
    `/plant/list?sales_org_code=${sales}&distribution_channel=${distribution}&material_number=${number}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getPlantV2 = (sales = '', number = '') => {
  return api_masterdata_v2.get(
    `/plant/list?sales_org_code=${sales}&material_number=${number}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getRoute = (sales) => {
  return api_masterdata.get(`/route/list?sales_org=${sales}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPayment = (cust, comp) => {
  return api_masterdata.get(
    `/customer/payment/payment-support?customer_code=${cust}&sales_org_code=${comp}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getProductType = (credential) => {
  return api_masterdata.get(`/material-group/list?credentials=${credential}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getProductName = (plant, dist, group, sales, sektor, options) => {
  const param = {
    distribution_channel: dist,
    material_group: group,
    company_code: sales,
    sector_id: sektor,

    city_code: options?.city || '',
    incoterm: options?.incoterm || '',
    customer_code: options?.customer_code || '',
    plant: plant || '',
  }
  const query = new URLSearchParams(param)

  return api_masterdata.get(
    `/material-product/list?` + query,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getSectorAll = () => {
  return api_usermanagement.get(`/sector/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getOptionalTextModules = () => {
  return api_usermanagement.get(`/config/additional-text/modules`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getPaymentAll = (filter = '') => {
  return api_masterdata.get(`/payment-type/list${filter}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSalesAreaAll = () => {
  return api_usermanagement.get(`/sales-org/`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getProvince2 = (sales_org, distribution_channel) => {
  return api_masterdata.get(
    `/sales-area-assignment/list?sales_org=${sales_org}&distribution_channel=${distribution_channel}&division=ZZ`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getProvince3 = (options = {}) => {
  const opt = new URLSearchParams(options).toString()
  return api_masterdata.get(`/sales-office/list?` + opt , {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getStock = (data) => {
  return api_masterdata.post(`/stock/check`, data, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getFindoc = (cust, sales, incotermId = '') => {
  return api_usermanagement.get(
    `/findoc/list?customer_code=${cust}&status=4&sales_org_code=${sales}&incoterm_id=${incotermId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getFindocDataTable = (cust, sales, incotermId, incotermId2, currency, flag = 0) => {
  return api_usermanagement.get(
    `/findoc?customer_code=${cust}&status=5&sales_org_code=${sales}&incoterm_id=${incotermId}&incoterm2_id=${incotermId2}&currency=${currency}&credentials=${localStorage.getItem(
      'credential'
    )}&flag=${flag}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const findocForSO = (params = {}) => {
  const queryString = createQueryString({... params, status: 5, flag: 1})
  return api_usermanagement.get(`/findoc?${queryString}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'X-Credentials': localStorage.getItem('credential')
      },
    })
}

const paginationAPI = (endpint, params = {}) => {
  const queryString = createQueryString({... params, status: 5, flag: 1})
  return axios.get(`${endpint}&${queryString}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'X-Credentials': localStorage.getItem('credential')
      },
    })
}

const getFindocDataTableSearch = (
  cust,
  sales,
  incotermId,
  incotermId2,
  desc,
  ext,
  currency = '',
  sap_number = ''
) => {
  return api_usermanagement.get(
    `/findoc?customer_code=${cust}&status=5&sales_org_code=${sales}&incoterm_id=${incotermId}&incoterm2_id=${incotermId2}&findoc_desc=${desc}&num_findoc=${ext}&currency=${currency}&sap_number=${sap_number}&credentials=${localStorage.getItem(
      'credential'
    )}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getTOPCust = (id) => {
  return api_masterdata.get(`/customer/sales-area/list?customer_code=${id}&division=ZZ`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getTOPAnper = () => {
  return api_masterdata.get(`/term-of-payment/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSloc = (plant, lang, mat, quantum, type) => {
  return api_masterdata.get(
    `/sloc/list/${lang}?plant=${plant}&material_number=${mat}&fixed_quantum=${quantum}&product_type=${type}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getCustomer = (code, name) => {
  return api_masterdata.get(`/customer?customer_code=${code}&name=${name}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getCustomerDt = (code) => {
  return api_usermanagement.get(`/customer/detail?customer_code=${code}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}


const getLogSAP = (
  req = '',
  res = '',
  status = '',
  ipres = '',
  reqtype = '',
  message = '',
  create = ''
) => {
  return api_sap.get(
    `/log?request=${req}&response=${res}&status=${status}&ip_response=${ipres}&request_type=${reqtype}&message=${message}&created_at=${create}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getLogH2H = (
  timestamp = '',
  penebusan = '',
  ip = '',
  requester = '',
  request = '',
  http = '',
  status = '',
  timestamp2 = '',
  ipresp = ''
) => {
  return api_h2h.get(
    `/log-h2h?timestamp_request=${timestamp}&no_penebusan=${penebusan}&ip_request=${ip}&pengirim_request=${requester}&request_type=${request}&http=${http}&status=${status}&timestamp_response=${timestamp2}&ip_response=${ipresp}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getLogAPI = (
  created = '',
  agent = '',
  ipadd = '',
  method = '',
  body = '',
  status = '',
  message = '',
  response = '',
  requesttype = '',
  path = '',
  eCode = ''
) => {
  return api_usermanagement.get(
    `/log/api?created_at=${created}&agent=${agent}&ip_addres=${ipadd}&method=${method}&body=${body}&status=${status}&message=${message}&response=${response}&request_type=${requesttype}&path=${path}&error_code=${eCode}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getSalesOfficeList = (sales = '') => {
  return api_masterdata.get(`/sales-office/list?sales_office=${sales}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getSalesAreaSO = (sales, dist) => {
  return api_masterdata.get(
    `/sales-area/list?sales_org=${sales}&division=ZZ&distribution_channel=${dist}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    }
  )
}

const getAllPaymentList = (sector_id) => {
  const sectorId = sector_id || ''
  return api_masterdata.get(`/payment-type/list?sector_id=${sectorId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getUserDetail = (secId, cusId) => {
  return api_usermanagement.get(`/config/address?sector_id=${secId}&customer_id=${cusId}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getFooterContent = (salesOrg, module) => {
  return api_usermanagement.get(`/config/letter/get?sales_org_code=${salesOrg}&module=${module}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getCountryList = () => {
  return api_masterdata.get(`/countries/list`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

const getLogSAPTypes = () => {
  return api_sap.get(`/log/types`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  })
}

export {
  getCountryList,
  getFooterContent,
  getUserDetail,
  getSalesArea,
  getSalesAreaLetter,
  getEndUser,
  getSector,
  getIncoterm,
  getProvince,
  getCity,
  getProdusen,
  getTOP,
  getSupplyPoint,
  getPlant,
  getPayment,
  getProductType,
  getProductName,
  getSectorAll,
  getOptionalTextModules,
  getPaymentAll,
  getSalesAreaAll,
  getProvince2,
  getStock,
  getPlant2,
  getFindoc,
  getTOPAnper,
  getTOPCust,
  getFindocDataTable,
  getFindocDataTableSearch,
  getSloc,
  getAllEndUser,
  getRoute,
  getCustomer,
  getLogSAP,
  getLogH2H,
  getSalesOfficeList,
  getLogAPI,
  getSalesAreaSO,
  getProvince3,
  getAllPaymentList,
  getPlantV2,
  getCustomerDt,
  getFindocTypes,
  findocForSO,
  paginationAPI,
  getLogSAPTypes,
  getCommodities
}
